export enum MembershipStatusFilter {
  All = 'All',
  ActiveAndFuture = 'ActiveAndFuture',
  Expired = 'Expired',
}
